import { LoginService } from 'src/app/login/login.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent,  HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { Injector, Injectable } from '@angular/core';
import  * as authService  from '../guard/auth.guard'
import { switchMap, take, filter, catchError, finalize } from 'rxjs/operators';
import {Router} from '@angular/router';



@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    isRefreshingToken : boolean = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null)

    constructor (private injector: Injector, private router: Router, private loginService: LoginService){}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const auth = this.injector.get(LoginService)

        if(auth.isLoggedIn()) {
            return <any> next.handle(this.addToken(req, sessionStorage.getItem("currentUser")))
                .pipe(catchError(err => {
                    if(err instanceof HttpErrorResponse) {
                        if(err.status === 401) {
                            return <any> this.naoAutorizado(req, next)
                        }
                        else
                        {
                            this.tokenSubject.next(sessionStorage.getItem('currentUser'))
                            return throwError(err)
                        }

                    } else {
                        console.log("Erro de protocolo http")
                        console.log(err)
                    }
                 }));
        }else {
            return next.handle(req)
        }
    }

    addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {

        if (req.url.includes("viacep")=== false) {
            return req.clone({ setHeaders: { Authorization: 'Bearer ' + token  ,authorizationServiceLayer : sessionStorage.getItem('TokenServiceLayer')}})
        }
        return req.clone()
    }

    naoAutorizado (req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        if(!this.isRefreshingToken) {
            this.isRefreshingToken = true

            this.tokenSubject.next(null)

            return this.loginService.refreshToken()
                        .pipe(switchMap((newToken: string) => {
                            if(newToken) {
                                // Armazenar token novo
                                sessionStorage.setItem("currentUser", newToken["token"])
                                sessionStorage.setItem("TokenServiceLayer", newToken["tokenServiceLayer"])
                                this.tokenSubject.next(newToken["token"])
                                return next.handle(this.addToken(req, newToken["token"]))
                            }

                        }), catchError (error => {
                            this.loginService.logout();
                            return throwError(error)
                        }), finalize(() => {
                            this.isRefreshingToken = false;
                        }))

        } else
         {
             return this.tokenSubject
                        .pipe(
                            filter(token => token != null)
                            ,take(1)
                            ,switchMap(token => {
                                return next.handle(this.addToken(req, token))
                            })
                        )
         }
    }

    // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     const auth = this.injector.get(authService.AuthGuard)

    //     if(auth.canActivate()){
    //         let authRequest = req.clone({setHeaders:{'authorization': 'Bearer ' + sessionStorage.getItem('currentUser'), 'authorizationServiceLayer' : sessionStorage.getItem('TokenServiceLayer')}})

    //         console.log("passou aqui")
    //         console.log(authRequest)
    //         return next.handle(authRequest).pipe( tap(() => {},
    //             (err: any) => {
    //                 if (err instanceof HttpErrorResponse) {
    //                     console.log(err.status)
    //                     if (err.status !== 401) {
    //                         return;
    //                     }
    //                     this.loginService.refreshToken().subscribe(retorno => {
    //                         console.log("Token renovado")
    //                         console.log(retorno)
    //                         sessionStorage.setItem("currentUser", retorno.toString())
    //                         authRequest = req.clone({setHeaders:{'authorization': 'Bearer ' + retorno, 'authorizationServiceLayer' : sessionStorage.getItem('TokenServiceLayer')}})
    //                     }, (error) => {
    //                         console.log("Erro ao renovar token")
    //                         console.log(error)
    //                     })
    //                     return next.handle(authRequest)
    //                 }
    //             }
    //         ));
    //     }
    //     else {
    //         return next.handle(req)
    //     }
    // }


}
